export default __webpack_public_path__ + "static/granulation-617f9c0a1fcb5bbba64515cb4f67fad4.png";